const mall = [
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ '@/pages/cart/newCart.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '购物车',
        hasMenu: true
      }
    }
  },
  {
    path: '/submall',
    name: 'submall',
    component: () => import(/* webpackChunkName: "submall" */ '@/pages/mall/submall.vue'),
    meta: {
      // titleBar: {
      //   title: '',
      //   hasMenu: true
      // },
      keepAlive: []
    }
  },
  {
    path: '/drug/submall',
    name: '/drug/submall',
    component: () => import(/* webpackChunkName: "submall" */ '@/pages/newDrug/submall.vue'),
    meta: {
      titleBar: {
        title: '药品商城',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/newDrug/drug-list',
    name: 'drug-list',
    component: () => import(/* webpackChunkName: "submall" */ '@/pages/newDrug/drug-list.vue'),
    meta: {
      titleBar: {
        title: '药品商城',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/mall/drug',
    name: 'mall-drug',
    component: () => import(/* webpackChunkName: "drug" */ '@/pages/newDrug/drug.vue'),
    meta: {
      titleBar: {
        title: '药品商城',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/search/drug',
    name: 'search-drug',
    component: () => import(/* webpackChunkName: "drug" */ '@/pages/newSearch/drug.vue'),
    meta: {
      titleBar: {
        title: '药品商城',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  // 商品详情-预约类，暂时命名
  {
    path: '/drug-goods/:id',
    name: 'drug-goods',
    component: () => import(/* webpackChunkName: "goods" */ '@/pages/newDrug/goods.vue'),
    meta: {
      titleBar: {
        title: '商品详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/goods/:id',
    name: 'goods',
    component: () => import(/* webpackChunkName: "goods" */ '@/pages/store/goods.vue'),
    meta: {
      titleBar: {
        title: '商品详情',
        hasMenu: true
      }
    }
  },
  // 商城订单详情
  {
    path: '/store/order',
    name: 'store-order',
    component: () => import(/* webpackChunkName: "storeorder" */ '@/pages/store/order.vue'),
    meta: {
      titleBar: {
        title: '订单详情',
        hasMenu: true,
        login: true
      }
    }
  },
  {
    path: '/order-confirm',
    name: 'order-confirm',
    component: () => import(/* webpackChunkName: "orderconfirm" */ '@/pages/order/confirm.vue'),
    meta: {
      login: true,
      keepAlive: [],
      titleBar: {
        title: '确认订单',
        hasMenu: false
      }
    }
  },
  {
    path: '/booking',
    name: 'booking',
    component: () => import(/* webpackChunkName: "orderbooking" */ '@/pages/order/booking.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '预约服务',
        hasMenu: true
      }
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "pay" */ '@/pages/pay/pay.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '支付订单',
        hasMenu: false
      }
    }
  },
  {
    path: '/pay-suc',
    name: 'pay-suc',
    component: () => import(/* webpackChunkName: "paysuc" */ '@/pages/pay/pay-suc.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '支付订单',
        hasMenu: false
      }
    }
  },
  {
    path: '/drug-order',
    name: 'drug-order',
    component: () => import(/* webpackChunkName: "paysuc" */ '@/pages/order/drug-order.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '药品订单',
        hasMenu: true
      }
    }
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: () => import(/* webpackChunkName: "order-list" */ '@/pages/order/list.vue'),
    meta: {
      login: true,
      titleBar: false,
      keepAlive: []
    }
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    component: () => import(/* webpackChunkName: "order-detail" */ '@/pages/order/detail.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '订单详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/order-search',
    name: 'order-search',
    component: () => import(/* webpackChunkName: "order-search" */ '@/pages/order/order-search.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '搜索',
        hasMenu: true
      }
    }
  },
  {
    path: '/address',
    name: 'address-list',
    component: () => import(/* webpackChunkName: "addresslist" */ '@/pages/address/list.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '地址管理',
        hasMenu: false
      }
    }
  },
  {
    path: '/address-edit',
    name: 'address-edit',
    component: () => import(/* webpackChunkName: "addressedit" */ '@/pages/address/edit.vue'),
    meta: {
      login: true,
      titleBar: {
        title: '编辑地址',
        hasMenu: true
      }
    }
  }
]

export default mall
